import { useSyncExternalStore } from 'react';
import { RefreshCw } from 'lucide-react';

import {
  getServiceWorkerUpdateReady,
  subscribeServiceWorkerUpdateReady,
} from '../utils/serviceWorkerUpdates';

export default function ServiceWorkerUpdatePrompt({
  reload = () => window.location.reload(),
}: {
  reload?: () => void;
}) {
  const ready = useSyncExternalStore(
    subscribeServiceWorkerUpdateReady,
    getServiceWorkerUpdateReady,
    () => false,
  );

  if (!ready) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        alignItems: 'center',
        background: 'var(--card, #fff)',
        border: '1px solid var(--border, #e7e5e4)',
        borderRadius: 8,
        bottom: '1rem',
        boxShadow: '0 8px 24px rgba(28, 25, 23, 0.18)',
        color: 'var(--text, #1a1023)',
        display: 'flex',
        gap: '0.65rem',
        left: '1rem',
        maxWidth: 420,
        padding: '0.65rem 0.75rem',
        position: 'fixed',
        right: '1rem',
        zIndex: 10000,
      }}
    >
      <RefreshCw aria-hidden="true" size={16} style={{ flex: '0 0 auto' }} />
      <span style={{ flex: 1, fontSize: '0.85rem', fontWeight: 600 }}>
        New version of Valentine available
      </span>
      <button
        type="button"
        onClick={reload}
        style={{
          background: 'var(--primary, #f43f5e)',
          border: 'none',
          borderRadius: 6,
          color: '#fff',
          cursor: 'pointer',
          fontSize: '0.8rem',
          fontWeight: 600,
          padding: '0.4rem 0.7rem',
        }}
      >
        Reload
      </button>
    </div>
  );
}
